import Image from "@/components/AppImage";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";
import Link from "@/components/AppLink";
import index11_illu from "/public/img/index11-illu.png";

const Banner = () => {
  return (
    <section className="banner-section index-11">
      <div className="overlay">
        <div className="banner-content pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-10">
                <div className="main-content">
                  <h1>Run your freelance money from the OracleMarket app</h1>
                  <p className="xxlr">
                    Issue invoices, approve payouts, and watch balances in real
                    time—optimized for thumb-friendly workflows when you are
                    between meetings or on a job site.
                  </p>
                  <Link href={getDashboardPathUrl("/register")} className="cmn-btn">
                    Download the app
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-illu">
        <Image className="wow fadeInUp" src={index11_illu} alt="image" />
      </div>
    </section>
  );
};

export default Banner;
